import RegisterCardPopup from './RegisterCardPopup';
export default RegisterCardPopup;
